import React from "react";
import { UncontrolledTooltip } from "reactstrap";

const CustomTooltipWrapper = ({ target, tooltipBody }) => {
  return <UncontrolledTooltip target={target}>{tooltipBody}</UncontrolledTooltip>;
};

export default CustomTooltipWrapper;
